import React, { useEffect } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { motion } from "framer-motion";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import storyVideo from "../../Logo/Homely Logo 2.mp4";

const offerings = [
  {
    index: "01",
    title: "Construction",
    description:
      "End-to-end project expertise, from considered planning and design through to careful execution and delivery.",
  },
  {
    index: "02",
    title: "Real estate",
    description:
      "Thoughtfully planned living spaces that bring modern comfort, lasting quality, and a sense of community together.",
  },
];

const AboutUsSection2 = ({ setIsFormOpen }) => {
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ backgroundColor: "#f6f4ef" }}>
      <Box
        sx={{
          position: "relative",
          minHeight: { xs: 480, md: 650 },
          display: "flex",
          alignItems: "flex-end",
          overflow: "hidden",
          backgroundColor: "#292720",
        }}
      >
        <Box
          component="video"
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          sx={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src={storyVideo} type="video/mp4" />
        </Box>
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(90deg, rgba(20,19,16,0.72), rgba(20,19,16,0.12)), linear-gradient(0deg, rgba(20,19,16,0.65), transparent 75%)",
          }}
        />
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.75, ease: [0.22, 1, 0.36, 1] }}
          style={{
            position: "relative",
            zIndex: 1,
            maxWidth: 850,
            padding: "clamp(28px, 8vw, 100px)",
          }}
        >
          <Typography
            sx={{
              mb: 2,
              color: "#e2c796",
              fontSize: "0.68rem",
              fontWeight: 600,
              letterSpacing: "0.2em",
            }}
          >
            OUR STORY
          </Typography>
          <Typography
            component="h1"
            sx={{
              color: "white",
              fontFamily: 'Georgia, "Times New Roman", serif',
              fontSize: { xs: "3rem", md: "5.2rem" },
              lineHeight: 1.04,
            }}
          >
            Building for the
            <br />
            life you imagine.
          </Typography>
          <Typography
            sx={{
              mt: 2.5,
              maxWidth: 560,
              color: "rgba(255,255,255,0.82)",
              fontSize: { xs: "0.92rem", md: "1rem" },
              lineHeight: 1.8,
            }}
          >
            Your trusted partner in thoughtful construction and real-estate
            development since 2017.
          </Typography>
        </motion.div>
      </Box>

      <Box sx={{ maxWidth: 1180, mx: "auto", px: { xs: 3, md: 7 }, py: { xs: 7, md: 11 } }}>
        <Grid container spacing={{ xs: 3, md: 8 }} alignItems="flex-start">
          <Grid item xs={12} md={4}>
            <Typography
              sx={{
                color: "#9a794b",
                fontSize: "0.68rem",
                fontWeight: 600,
                letterSpacing: "0.18em",
              }}
            >
              WHO WE ARE
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.35 }}
              transition={{ duration: 0.65, ease: "easeOut" }}
            >
              <Typography
                component="h2"
                variant="h3"
                sx={{
                  mb: 2.5,
                  maxWidth: 820,
                  fontSize: { xs: "2.2rem", md: "3.2rem" },
                  lineHeight: 1.18,
                }}
              >
                We believe a home is more than the walls around you.
              </Typography>
              <Typography
                sx={{
                  maxWidth: 760,
                  color: "text.secondary",
                  fontSize: "1rem",
                  lineHeight: 1.9,
                }}
              >
                Incorporated on September 17, 2017, and established on
                November 9, 2017, Homely Buildofiy brings construction
                expertise and real-estate development together. We combine
                dependable project delivery with a personal understanding of
                how people want to live—creating spaces made to feel welcoming,
                work beautifully, and stand the test of time.
              </Typography>
            </motion.div>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ px: { xs: 3, md: 7 }, py: { xs: 7, md: 9 }, backgroundColor: "#eeece5" }}>
        <Box sx={{ maxWidth: 1180, mx: "auto" }}>
          <Typography
            sx={{
              mb: 1.5,
              color: "#9a794b",
              fontSize: "0.68rem",
              fontWeight: 600,
              letterSpacing: "0.18em",
            }}
          >
            WHAT WE DO
          </Typography>
          <Typography
            component="h2"
            variant="h3"
            sx={{ mb: { xs: 3, md: 5 }, fontSize: { xs: "2.2rem", md: "3rem" } }}
          >
            One partner, from plan to place.
          </Typography>
          <Grid container spacing={2}>
            {offerings.map((offering, index) => (
              <Grid item xs={12} md={6} key={offering.index}>
                <motion.div
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.25 }}
                  transition={{ duration: 0.6, delay: index * 0.12 }}
                  style={{ height: "100%" }}
                >
                  <Box
                    sx={{
                      height: "100%",
                      minHeight: 230,
                      p: { xs: 3, md: 4 },
                      backgroundColor: "#f6f4ef",
                    }}
                  >
                    <Typography
                      sx={{
                        mb: 4,
                        color: "#9a794b",
                        fontSize: "0.68rem",
                        fontWeight: 600,
                        letterSpacing: "0.12em",
                      }}
                    >
                      {offering.index}
                    </Typography>
                    <Typography
                      component="h3"
                      sx={{
                        mb: 1.3,
                        color: "#292720",
                        fontFamily: 'Georgia, "Times New Roman", serif',
                        fontSize: "1.8rem",
                      }}
                    >
                      {offering.title}
                    </Typography>
                    <Typography sx={{ maxWidth: 470, color: "text.secondary", lineHeight: 1.8 }}>
                      {offering.description}
                    </Typography>
                  </Box>
                </motion.div>
              </Grid>
            ))}
          </Grid>
          <Button
            onClick={() => history.push("/construction")}
            endIcon={<ArrowForwardIcon />}
            sx={{
              mt: 3,
              px: 0,
              color: "#292720",
              fontSize: "0.7rem",
              fontWeight: 600,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              "&:hover": { backgroundColor: "transparent", color: "#9a794b" },
            }}
          >
            Explore our work
          </Button>
        </Box>
      </Box>

      <Box sx={{ maxWidth: 1180, mx: "auto", px: { xs: 3, md: 7 }, py: { xs: 7, md: 10 } }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.65, ease: "easeOut" }}
        >
          <Typography
            sx={{
              mb: 1.5,
              color: "#9a794b",
              fontSize: "0.68rem",
              fontWeight: 600,
              letterSpacing: "0.18em",
            }}
          >
            OUR PROMISE
          </Typography>
          <Typography
            component="h2"
            variant="h3"
            sx={{ maxWidth: 850, mb: 2.5, fontSize: { xs: "2.2rem", md: "3.2rem" } }}
          >
            Every project is a promise to deliver spaces that inspire and endure.
          </Typography>
          <Typography sx={{ maxWidth: 720, color: "text.secondary", lineHeight: 1.85 }}>
            We are dedicated to exceeding expectations and making every
            customer&apos;s journey as considered and memorable as the places we
            create.
          </Typography>
          <Button
            variant="outlined"
            onClick={() => setIsFormOpen(true)}
            sx={{
              mt: 3.5,
              px: 3,
              py: 1.35,
              borderColor: "#292720",
              borderRadius: 0,
              color: "#292720",
              fontSize: "0.68rem",
              fontWeight: 600,
              letterSpacing: "0.1em",
              "&:hover": { borderColor: "#9a794b", color: "#9a794b" },
            }}
          >
            Enquire with our team
          </Button>
        </motion.div>
      </Box>

      <Box sx={{ backgroundColor: "#292720", color: "white" }}>
        <Box
          sx={{
            maxWidth: 1180,
            mx: "auto",
            px: { xs: 3, md: 7 },
            py: { xs: 6, md: 8 },
          }}
        >
          <Typography
            sx={{
              mb: 1.5,
              color: "#e2c796",
              fontSize: "0.68rem",
              fontWeight: 600,
              letterSpacing: "0.18em",
            }}
          >
            RECOGNITION
          </Typography>
          <Typography
            component="h2"
            sx={{
              mb: 2,
              color: "white",
              fontFamily: 'Georgia, "Times New Roman", serif',
              fontSize: { xs: "2.2rem", md: "3rem" },
            }}
          >
            Recognized for what we build—and how we build it.
          </Typography>
          <Typography sx={{ maxWidth: 760, color: "rgba(255,255,255,0.72)", lineHeight: 1.85 }}>
            We are proud to be recognized by Startup Odisha and Startup India,
            reflecting our commitment to innovation, entrepreneurship, and
            contributing to the growth of the nation.
          </Typography>
        </Box>
      </Box>

      <Box sx={{ backgroundColor: "#eeece5" }}>
        <Box sx={{ maxWidth: 1180, mx: "auto", px: { xs: 3, md: 7 }, pt: { xs: 6, md: 8 } }}>
          <Typography
            sx={{
              mb: 1.5,
              color: "#9a794b",
              fontSize: "0.68rem",
              fontWeight: 600,
              letterSpacing: "0.18em",
            }}
          >
            FIND US
          </Typography>
          <Typography component="h2" variant="h3" sx={{ mb: 3, fontSize: { xs: "2rem", md: "2.7rem" } }}>
            Rooted in Bargarh, Odisha.
          </Typography>
        </Box>
        <Box sx={{ maxWidth: 1180, mx: "auto", px: { xs: 2, md: 7 }, pb: { xs: 6, md: 8 } }}>
          <Box
            sx={{
              width: "100%",
              height: { xs: 300, md: 420 },
              overflow: "hidden",
              backgroundColor: "#d9d5ca",
            }}
          >
            <iframe
              title="Map showing Homely's location in Bargarh, Odisha"
              width="100%"
              height="100%"
              frameBorder="0"
              loading="lazy"
              src="https://maps.google.com/maps?width=100%25&amp;height=400&amp;hl=en&amp;q=Old%20NH-6%20Near%20Bandutikra%20Chowk,%20Bargarh,%20Odisha%20768028+(Homely)&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              style={{ border: 0, display: "block" }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutUsSection2;
